import React, { useState } from 'react';
import './blocks/ModernBlocks.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'Security System Quote Request',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: 'Security System Quote Request',
        message: ''
      });
      
      // Reset status after 3 seconds
      setTimeout(() => setSubmitStatus(null), 3000);
    }, 1500);
  };

  return (
    <div className="contact-page-new">
      {/* Hero Section */}
      <div className="contact-hero-new">
        <div className="contact-hero-content">
          <h1 className="contact-hero-title-new">Get Your Free Security Assessment</h1>
          <p className="contact-hero-subtitle-new">
            Contact our security experts for a comprehensive assessment of your property. 
            We'll design a custom security solution that fits your needs and budget.
          </p>
        </div>
      </div>

      {/* Main Contact Section */}
      <div className="contact-main-new">
        <div className="contact-card-new">
          {/* Left Side - Contact Information */}
          <div className="contact-info-new">
            <div className="contact-info-content-new">
              <h2 className="contact-info-title-new">Contact Information</h2>
              <p className="contact-info-subtitle-new">
                Get in touch with our security experts for professional consultation and support.
              </p>
              
              <div className="contact-details-new">
                <div className="contact-detail-item-new">
                  <div className="contact-icon-new">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div className="contact-text-new">
                    <p>+1 (555) 123-4567</p>
                    <p>Emergency: +1 (555) 911-0000</p>
                  </div>
                </div>

                <div className="contact-detail-item-new">
                  <div className="contact-icon-new">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div className="contact-text-new">
                    <p>info@secureguard.com</p>
                    <p>support@secureguard.com</p>
                  </div>
                </div>

                <div className="contact-detail-item-new">
                  <div className="contact-icon-new">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div className="contact-text-new">
                    <p>123 Security Drive</p>
                    <p>Safety City, SC 12345</p>
                  </div>
                </div>
              </div>

              {/* Decorative Circle */}
              <div className="contact-decorative-circle"></div>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="contact-form-new">
            <form className="contact-form-content-new" onSubmit={handleSubmit}>
              <div className="form-field-new">
                <label htmlFor="name" className="form-label-new">Your Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="form-input-new"
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="form-field-new">
                <label htmlFor="email" className="form-label-new">Your Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input-new"
                  placeholder="Enter your email address"
                  required
                />
              </div>

              <div className="form-field-new">
                <label htmlFor="subject" className="form-label-new">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className="form-input-new"
                  placeholder="Security System Quote Request"
                />
              </div>

              <div className="form-field-new">
                <label htmlFor="message" className="form-label-new">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="form-textarea-new"
                  rows="6"
                  placeholder="Tell us about your security needs, property type, and any specific requirements..."
                  required
                ></textarea>
              </div>

              <button 
                type="submit" 
                className={`contact-submit-new ${isSubmitting ? 'loading' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Get Free Security Assessment'}
              </button>

              {submitStatus === 'success' && (
                <div className="contact-success-new">
                  Thank you! Your security assessment request has been sent successfully. 
                  Our team will contact you within 24 hours to schedule your free consultation.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 